import React from "react";
import { Link } from "react-router-dom";
import RoboticsShell from "./RoboticsShell";
import PortraitSilhouette from "./PortraitSilhouette";

/**
 * Meet page — 8-tile grid.
 *   2 primary Clarke dramas (linked to detail pages)
 * + 6 placeholder engineer heroes shipping in Phase 3.
 */
export default function RoboticsMeet() {
  return (
    <RoboticsShell>
      <section className="rbx-page" data-testid="rbx-page-meet">
        <span className="rbx-eyebrow">Section · Meet the engineers</span>
        <h1 className="rbx-page__title" data-testid="rbx-meet-title">
          Meet the engineers who bent the future.
        </h1>
        <p className="rbx-page__lede">
          Two flagship storybook dramas and six engineer portraits ship as
          audio-first mini-lessons. Each portrait is a 2-minute story you can
          play while walking to school.
        </p>

        <div className="rbx-heroes-grid" data-testid="rbx-heroes-grid">
          {HEROES.map((h) => (
            <article key={h.slug} className="rbx-card rbx-hero-tile" data-testid={`rbx-hero-${h.slug}`}>
              <div className="rbx-hero-tile__portrait">
                <PortraitSilhouette tone={h.tone} />
              </div>
              <div className="rbx-hero-tile__body">
                <div className="rbx-hero-tile__name">{h.name}</div>
                <div className="rbx-hero-tile__role">{h.role}</div>
                {h.status === "ready" ? (
                  <Link className="rbx-btn rbx-btn--ghost" to={`/robotics/meet/${h.slug}`}
                        data-testid={`rbx-hero-${h.slug}-link`}
                        style={{ padding: "8px 14px", fontSize: 12 }}>
                    Preview →
                  </Link>
                ) : (
                  <span className="rbx-chip-q4" data-testid={`rbx-hero-${h.slug}-chip`}>Coming Phase 3</span>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </RoboticsShell>
  );
}

const HEROES = [
  { slug: "arthur_clarke",    name: "Sir Arthur C. Clarke", role: "Sri Lanka · Satellite pioneer", tone: "warm", status: "ready" },
  { slug: "clarke_orbit",     name: "Clarke's Orbit",       role: "The 1945 prediction",           tone: "warm", status: "ready" },
  { slug: "nikola_tesla",     name: "Nikola Tesla",         role: "AC electricity",                tone: "cool", status: "soon"  },
  { slug: "alan_turing",      name: "Alan Turing",          role: "Computing · codebreaking",      tone: "cool", status: "soon"  },
  { slug: "marie_curie",      name: "Marie Curie",          role: "Radioactivity",                 tone: "warm", status: "soon"  },
  { slug: "ada_lovelace",     name: "Ada Lovelace",         role: "First programmer",              tone: "warm", status: "soon"  },
  { slug: "grace_hopper",     name: "Grace Hopper",         role: "COBOL · debug origin",          tone: "warm", status: "soon"  },
  { slug: "katherine_johnson",name: "Katherine Johnson",    role: "NASA orbital mechanics",        tone: "warm", status: "soon"  },
];
